import { useQuery } from 'data-fetching-client';
import ModuleDetailsResponse from 'marketplace-ui-assets-core/details/records/ModuleDetailsResponse';
import { useUnifiedDetails } from 'marketplace-ui-details/hooks/useUnifiedDetails';
import { useMemo } from 'react';
import { GET_MODULE_DETAILS } from '../queries/moduleDetailsQuery';
export function useModuleDetails({
  isUngatedForUnifiedDetails,
  slug
}) {
  // We can't use the Unified Details CHIRP endpoint in the public marketplace.
  // Because we're rolling it out behind a gate, and a public user will always be
  // !isUngatedForUnifiedDetails, this logic still works, but if we remove the gate,
  // we'll need to account for public users.
  const {
    unifiedDetailsData,
    unifiedDetailsLoading,
    unifiedDetailsError,
    previousUnifiedDetailsData
  } = useUnifiedDetails({
    slug,
    skip: !isUngatedForUnifiedDetails
  });
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_MODULE_DETAILS, {
    variables: {
      slug
    },
    skip: isUngatedForUnifiedDetails
  });
  const moduleDetails = useMemo(() => {
    let moduleDetailsData;
    if (isUngatedForUnifiedDetails) {
      moduleDetailsData = unifiedDetailsData || previousUnifiedDetailsData;
      return new ModuleDetailsResponse(moduleDetailsData);
    } else {
      moduleDetailsData = data || previousData;
      return new ModuleDetailsResponse(moduleDetailsData ? moduleDetailsData.details : undefined);
    }
  }, [data, previousData, unifiedDetailsData, previousUnifiedDetailsData, isUngatedForUnifiedDetails]);
  return {
    loading: isUngatedForUnifiedDetails ? unifiedDetailsLoading : loading,
    error: isUngatedForUnifiedDetails ? unifiedDetailsError : error,
    moduleDetails
  };
}